import { cx } from "@emotion/css";
import PaymentIcon from "@mui/icons-material/CreditCardOutlined";
import { unwrapResult } from "@reduxjs/toolkit";
import useDeviceType from "hooks/useDeviceType";
import useOpenClose from "hooks/useOpenClose";
import SecondaryButton from "library/Atoms/Button/SecondaryButton";
import MessageLayout from "library/Layouts/MessageLayout";
import useOrders from "pages/Dashboard/hooks/useOrders";
import PropTypes from "prop-types";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { checkoutOrderRequest } from "store/requests/payment.request";
import { PAID_PAYMENT_STATUS, PENDING_PAYMENT_STATUS } from "../../../../../constants";
import styles from "./PaymentBanner.styles";

const PaymentBanner = ({ onStartPayment }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { isDesktop } = useDeviceType();

  const [{ selectedOrder }] = useOrders();

  const [isLoading, startLoading, stopLoading] = useOpenClose(false);

  const onClick = useCallback(() => {
    startLoading();

    dispatch(checkoutOrderRequest({ lines: [], orderId: selectedOrder.id }))
      .then(unwrapResult)
      .then(({ data }) => {
        if (![PENDING_PAYMENT_STATUS, PAID_PAYMENT_STATUS].includes(data.paymentStatus)) onStartPayment();
      })
      .catch(() => {})
      .finally(() => stopLoading());
  }, [dispatch, onStartPayment, selectedOrder.id, startLoading, stopLoading]);

  return (
    <>
      <MessageLayout
        id="payment-banner"
        className="flex-1"
        contentClassName="text-fs-12"
        labelSection={t("dashboard.order.paymentBanner.description")}
        color="warning"
      />

      <SecondaryButton
        className={cx(styles.btn(isDesktop), "w-100")}
        contentClassName="text-fs-12"
        label={t("common.buttons.payBtn")}
        onClick={onClick}
        color="warning"
        endIcon={<PaymentIcon />}
        loading={isLoading}
      />
    </>
  );
};

PaymentBanner.propTypes = {
  onStartPayment: PropTypes.func.isRequired,
};

export default PaymentBanner;
